<template>
    <div class="full" style="position: relative">
        <div class="main">
            <router-view />
        </div>
        <player-navigation />
    </div>
</template>

<script>
import playerNavigation from "@/components/Player/Player-navigation";
export default {
    name: "player",
    components: { playerNavigation },
};
</script>

<style lang="scss">
.full {
    height: 100%;
    min-height: -webkit-fill-available;
}
</style>
